<script setup lang="ts">
  import { inject } from 'vue';

  import { DESCRIPTION_LIST_INJECTION } from '../DescriptionList/DescriptionList.keys';

  const descriptionListInjectedValues = inject(DESCRIPTION_LIST_INJECTION.key);
  if (!descriptionListInjectedValues) {
    throw new Error('DescriptionListDetail must be used within a DescriptionList component.');
  }
  const { divide, variant } = descriptionListInjectedValues;
</script>

<template>
  <div
    class="stash-description-list-group"
    :class="{
      'md:flex md:items-start md:gap-x-6': variant === 'columns' || variant === 'space-between',
      'justify-between': variant === 'space-between',
      'md:flex md:items-start': variant === 'inline',
      'py-1.5 first:pt-0 last:pb-0': !divide,
      'py-3 first:pt-0 last:pb-0': divide,
    }"
    data-test="stash-description-list-group"
    :data-divide="divide"
    :data-variant="variant"
  >
    <!-- @slot Default slot, for rendering a description detail -->
    <slot></slot>
  </div>
</template>
